// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDivvylb-jF1fuqAzJhTb-H8RpHLNedBgg",
  authDomain: "simple-react-firebase-7f125.firebaseapp.com",
  projectId: "simple-react-firebase-7f125",
  storageBucket: "simple-react-firebase-7f125.appspot.com",
  messagingSenderId: "96045504009",
  appId: "1:96045504009:web:8920defd13c8a522378ad8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;